import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");

    if (!token) {
      setErr("Link reset password tidak valid.");
      return;
    }

    if (password.length < 6) {
      setErr("Password minimal 6 karakter.");
      return;
    }

    if (password !== confirm) {
      setErr("Konfirmasi password tidak sama.");
      return;
    }

    setLoading(true);

    try {
      await api.post("/auth/reset-password", {
        token,
        password,
      });

      setDone(true);
      toast.success("Password berhasil diubah");
    } catch (e2) {
      const msg = formatApiError(e2.response?.data?.detail) || e2.message;
      setErr(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 grid place-items-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 justify-center mb-2">
          <img
            src="/assets/jagaomzet-logo.svg"
            alt="JagaOmzet"
            className="w-10 h-10 rounded-xl"
          />
          <div className="text-left leading-tight">
            <span className="font-extrabold text-xl tracking-tight block">
              JagaOmzet
            </span>
            <span className="text-[11px] text-zinc-400 font-medium">
              Pembeli Balik, Omzet Naik.
            </span>
          </div>
        </div>

        <div className="bg-white border border-zinc-200 rounded-2xl p-6 sm:p-8 shadow-sm">
          <h1 className="text-2xl font-bold tracking-tight">
            Reset Password
          </h1>

          {done ? (
            <div className="mt-6 space-y-4">
              <div className="rounded-xl bg-emerald-50 border border-emerald-100 p-4 text-sm text-emerald-800">
                Password berhasil diubah. Silakan masuk dengan password baru.
              </div>

              <Button
                onClick={() => navigate("/login")}
                className="w-full bg-emerald-600 hover:bg-emerald-700"
              >
                Kembali ke Login
              </Button>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="password">Password Baru</Label>
                <Input
                  id="password"
                  type="password"
                  required
                  minLength={6}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Minimal 6 karakter"
                />
              </div>

              <div className="space-y-1.5">
                <Label htmlFor="confirm">Konfirmasi Password</Label>
                <Input
                  id="confirm"
                  type="password"
                  required
                  minLength={6}
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="Ulangi password baru"
                />
              </div>

              {err && (
                <div className="text-sm text-red-600">
                  {err}
                </div>
              )}

              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-emerald-600 hover:bg-emerald-700"
              >
                {loading ? "Menyimpan..." : "Simpan Password Baru"}
              </Button>

              <Link
                to="/login"
                className="block text-center text-sm text-zinc-500 hover:text-zinc-900"
              >
                Kembali ke Login
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
